module.exports = __webpack_public_path__ + "static/media/estateEmbracon.7c2495c4.jpg";